import React from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Card, CardBody } from 'reactstrap';
import { SPECIALTY_IDS, getSpecialty } from 'config/specialtyConfig';
import { getSpecialtyFields, qualifiesForAddon, ADDON_DISCOUNT_PERCENT } from 'config/subscriptionPlans';
import { switchSpecialty } from 'redux/Specialty/SpecialtyAction';
import CurrentSubscriptionCard from './CurrentSubscriptionCard';

const AllSpecialtiesSubscriptionStatus = ({ userDetails, activeSpecialty }) => {
    const history = useHistory();
    const dispatch = useDispatch();

    if (!userDetails) return null;

    return (
        <>
            {SPECIALTY_IDS.map(specId => {
                const fields = getSpecialtyFields(specId);
                const spec = getSpecialty(specId);

                // Check if user has ANY data for this specialty
                const hasData = !!(
                    userDetails[fields.trialStartDate] ||
                    userDetails[fields.subscriptionEndDate] ||
                    userDetails[fields.lifetimeAccess] === true ||
                    userDetails[fields.lifetimeAccess] === 'true' ||
                    userDetails[fields.ultimateAdvisingStudent] === true ||
                    userDetails[fields.ultimateAdvisingStudent] === 'true'
                );

                if (hasData) {
                    return (
                        <div key={specId} className="mb-3">
                            <CurrentSubscriptionCard overrideSpecialty={specId} />
                        </div>
                    );
                }

                // No data — show "Not purchased" card, with addon promo if eligible
                const canAddon = qualifiesForAddon(userDetails, specId);

                return (
                    <div key={specId} className="mb-3">
                        <Card className="shadow border-0" style={{ overflow: 'hidden' }}>
                            <div className={canAddon ? "bg-gradient-success" : "bg-gradient-default"} style={{ height: '4px' }} />
                            <CardBody className="p-4">
                                <div className="d-flex align-items-center flex-wrap">
                                    <div
                                        className={`icon icon-shape ${canAddon ? 'bg-gradient-success' : 'bg-gradient-default'} text-white rounded-circle shadow mr-3`}
                                        style={{ width: '64px', height: '64px', minWidth: '64px' }}
                                    >
                                        <i className={spec.icon} style={{ fontSize: '1.75rem' }} />
                                    </div>
                                    <div className="flex-grow-1 mr-3" style={{ minWidth: 0 }}>
                                        <h6
                                            className="text-uppercase text-muted mb-1 font-weight-bold"
                                            style={{ letterSpacing: '0.05em', fontSize: '0.7rem' }}
                                        >
                                            <i className={`${spec.icon} mr-1`} />
                                            {spec.name} — Subscription Status
                                        </h6>
                                        <h2 className="mb-1 text-muted" style={{ lineHeight: 1.2 }}>
                                            Not Purchased
                                        </h2>
                                        {canAddon ? (
                                            <p className="text-success mb-0 small font-weight-bold">
                                                <i className="fas fa-tag mr-1" />
                                                Save {ADDON_DISCOUNT_PERCENT}% — add this to your account
                                            </p>
                                        ) : (
                                            <p className="text-muted mb-0 small">
                                                Explore the {spec.name} question bank
                                            </p>
                                        )}
                                    </div>
                                    <button
                                        className={`btn ${canAddon ? 'btn-success' : 'btn-outline-success'} mt-2 mt-sm-0`}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            if (specId !== activeSpecialty) {
                                                dispatch(switchSpecialty(specId));
                                            }
                                            history.push('/client/plans');
                                        }}
                                    >
                                        <i className={`fas ${canAddon ? 'fa-plus-circle' : 'fa-crown'} mr-1`} />
                                        {canAddon ? `Add ${spec.name}` : 'View Plans'}
                                    </button>
                                </div>
                            </CardBody>
                        </Card>
                    </div>
                );
            })}
        </>
    );
};

const mapStateToProps = state => ({
    userDetails: state.loginAuth.userDetails,
    activeSpecialty: state.specialty.activeSpecialty,
});

export default connect(mapStateToProps)(AllSpecialtiesSubscriptionStatus);
